<template>
  <a-modal
    ref="startCalculation"
    title=""
    :width="800"
    :visible="visible"
    :maskClosable="false"
    :footer="null"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-form layout="inline" class="full-width" :labelCol="{ style: { width: '80px' } }">
      <a-row>
        <a-col :md="24" :sm="24">
          <span class="title">运行计划</span>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-item class="item" label="运行方式">
            <!-- <a-radio-group @change="onTimeActionTypeChange" >
              <a-radio :timeActionType="1">
                立即运行
              </a-radio>
              <a-radio :timeActionType="2">
                指定时间
              </a-radio>
              <a-radio :timeActionType="3">
                定期重复运行
              </a-radio>
            </a-radio-group> -->
            <a-radio-group v-model="value" @change="onChange">
              <a-radio :value="1">
                立即运行
              </a-radio>
              <a-radio :value="2">
                指定时间
              </a-radio>
              <a-radio :value="3">
                定期重复运行
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :md="2" :sm="24"></a-col>
        <a-col v-if="value===2" :md="11" :sm="24">
          <a-form-item class="item" label="运行时间">
            <a-date-picker class="w120" show-time placeholder="请选择时间" @change="onRunningTimeChange" @ok="onRunningTimeOk" />
          </a-form-item>
        </a-col>
        <a-col v-if="value===3" :md="8" :sm="24">
          <a-form-item class="item" label="运行间隔">
            <a-input-number id="inputNumber" v-model="runIntervalTime" :min="1" />
          </a-form-item>
        </a-col>
        <a-col v-if="value===3" :md="11" :sm="24">
          <a-form-item class="item" label="起始时间">
            <a-date-picker class="w120" show-time placeholder="请选择时间" @change="onStartingTimeChange" @ok="onStartingTimeOk" />
          </a-form-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <span class="title">运行状态</span>
        </a-col>
        <a-col class="item" :md="24" :sm="24">
          <a-button @click="handleQuery" type="primary">启动</a-button>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import { apiStartCalculate } from '@/api/scp/shipmentForecast/shipmentForecastManagement'

// 表单字段
export default {
  props: {
    inventOrg: {
      type: Array,
      default: () => {
        return []
      }
    },
    workshopTypeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      value: 1,
      timeActionType: 1,
      runIntervalTime: '', // 运行间隔时间
      runningTime: '',
      startingTime: '',
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '车间类型',
          dataIndex: 'workshopType',
          width: 150,
          scopedSlots: { customRender: 'workshopType', title: "workshopTypeTitle" }
        },
        {
          // title: '加工组织',
          dataIndex: 'organizationCode',
          width: 180,
          scopedSlots: { customRender: 'organizationCode', title: "organizationCodeTitle" }
        },
        {
          // title: '车间编码',
          width: 150,
          dataIndex: 'workshopCode',
          scopedSlots: { customRender: 'workshopCode', title: "workshopCodeTitle" }
        },
        {
          title: '车间说明',
          width: 150,
          dataIndex: 'workshopDesc',
          scopedSlots: { customRender: 'workshopDesc' }
        },
        {
          title: '车间物控',
          dataIndex: 'workshopMcName',
          width: 150,
          scopedSlots: { customRender: 'workshopMcName' }
        },
        {
          // title: '默认工单分类',
          dataIndex: 'defaultJobClass',
          width: 150,
          scopedSlots: { customRender: 'defaultJobClass', title: "defaultJobClassTitle" }
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      typeList: [],
      workshopMcNameList: [], // 车间物控(缺接口数据)
      defaultJobClassList: []
    }
  },
  created () {},
  methods: {
    onChange (e) {
      console.log('radio checked', e.target.value);
    },
    onTimeActionTypeChange (value) {
    },
    onRunningTimeChange (value, dateString) {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    },
    onRunningTimeOk (value) {
      console.log('onOk: ', value);
      const formattedString = value.format('YYYY-MM-DD HH:mm:ss'); // 使用 format 方法将 Moment 对象转换为字符串
      this.runningTime = formattedString
    },
    onStartingTimeChange (value, dateString) {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    },
    onStartingTimeOk (value) {
      const formattedString = value.format('YYYY-MM-DD HH:mm:ss'); // 使用 format 方法将 Moment 对象转换为字符串
      this.startingTime = formattedString
    },
    handleQuery () {
      apiStartCalculate().then((response) => {
        if (response.code === 200) {
          this.$message.success('删除成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    show () {
      this.visible = true
    },
    // 关闭模态框
    close () {
      this.visible = false
    },
    confirm () {
    }
  }
}
</script>

<style scoped lang="less">

.organizationCode{
  /deep/.ant-select{
    width: 170px !important;
  }
}.title{
    font-weight: 650;
    font-style: normal;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.847);
    line-height: 24px;
    border-width: 0px;
}.item{
  margin: 20px 0 20px 60px;
}
</style>
